import {Fragment, useEffect, useState} from 'react';
import {SELECTED_MODE} from '@/constants/main';
import {getCookie, getUserCookie} from '@/utils/main';
import ContentTypeMain from '@/components/main/MyPlus/common/ContentType/ContentTypeMain';
import {CONTENT_NAME, TEMPLATE_NAME} from '@/constants/main/main-section';
import MyPlusApi from '@/api/main/my-plus';
import PreviewContentType from '@/components/main/MyPlus/common/ContentType/PreviewContentType';
import MainListBnContentType from '@/components/main/MyPlus/common/ContentType/MainListBnContentType';
import '/public/static/css/module/section.scss';
import {getDomParser} from '@/utils/main/my-plus/section';

const PopularSection = ({isSimplifyMode}) => {
  //데이터 로딩 상태
  const [isLoading, setIsLoading] = useState(false);
  const [adminSettingList, setAdminSettingList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [hiddenStreamer, setHiddenStreamer] = useState([]);

  const userAge = getUserCookie('age');
  const abroadChk = getCookie('AbroadChk'); // 해외여부 체크 (OK : 해외, FAIL: 국내)

  const getBlockStreamerAllList = async () => {
    try {
      const response = await MyPlusApi.getBlockStreamerAllList();
      if (response && response.result === 1) {
        setHiddenStreamer(response.data);
      }
    } catch (error) {
      setHiddenStreamer([]);
    }
  };

  const fetchPopularApi = async () => {
    const popularApi = MyPlusApi.getPopularListWithAdult;

    /** 250814
     *  연령제한 썸네일 개선 작업에서 19영상도 같이 출력으로 변경
          userAge >= 19
            ? MyPlusApi.getPopularListWithAdult
            : MyPlusApi.getPopularList;
    */

    const adminApi = MyPlusApi.getAdminPopularSettingList;
    //어드민 설정과 인기 리스트 둘다 필요해서 병렬처리
    const [popularRes, adminRes] = await Promise.all([
      popularApi(),
      adminApi(),
    ]);

    return {popularRes, adminRes};
  };

  const getPopularSectionList = async () => {
    setIsLoading(true);
    try {
      const {popularRes, adminRes} = await fetchPopularApi();

      setSectionList(popularRes);
      setAdminSettingList(adminRes);
    } catch (error) {
      setAdminSettingList([]);
      setSectionList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPopularSectionList();
    getBlockStreamerAllList();
  }, []);

  return (
    <>
      {adminSettingList.map((section) => {
        const code = section.sectionCode;
        const order = section.order;
        const item = sectionList.find((v) => v.sectionCode === code);
        const isAdult = section.isAdult; //성인만 노출 여부
        const abroadYn = section.abroadYn; //해외 노출 여부
        if (!item || item?.result !== 1 || item?.data.length === 0) {
          return null;
        }
        if (isAdult && userAge < 19) {
          return null;
        }
        if (!abroadYn && abroadChk === 'OK') {
          return null;
        }
        return (
          <Fragment key={code}>
            {/*
               Preview, MainListBanner 는 별도 템플릿이 없고 기존의 컴포넌트를 사용함.
               기존 컴포넌트들을 스타일을 유지해야해서 ContentTypeMain 에 넣지 않음.
            */}
            {section.contentType === CONTENT_NAME.PREVIEW ? (
              <PreviewContentType
                data={item.data}
                selectedMode={SELECTED_MODE.POPULAR}
                hiddenStreamer={hiddenStreamer}
                isSimplifyMode={isSimplifyMode}
                isLoading={isLoading}
              />
            ) : section.contentType === CONTENT_NAME.MAIN_LIST_BANNER ? (
              <MainListBnContentType data={item.data} />
            ) : (
              <ContentTypeMain
                data={item.data}
                hiddenStreamer={hiddenStreamer}
                contentType={section.contentType}
                selectedMode={SELECTED_MODE.POPULAR}
                template={TEMPLATE_NAME.DEFAULT}
                btnPosition={section.btnPosition}
                btnText={section.btnText}
                removeTitle={section.removeTitle}
                rowCount={section.rowCount}
                title={section.title}
                url={section.url}
                useSlider={section.useSlider}
                isLoading={isLoading}
                log={{
                  sectionIdx: order,
                  sectionTitle: getDomParser(section.title),
                }}
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default PopularSection;
